module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[33]398.42f2a41.woff2";